import React, {Component} from 'react';
import Breadcrumbs from "../../components/Baran/breadCrumbs/BreadCrumb";
import {
    Button,
    Card,
    CardBody,
    Col,
    Collapse,
    FormGroup,
    Input,
    Label,
    Media,
    Modal, ModalBody, ModalFooter,
    ModalHeader,
    Row, UncontrolledTooltip
} from "reactstrap";
import Select from "react-select";
import {AvFeedback, AvForm, AvGroup, AvInput} from "availity-reactstrap-validation";
import img from "../../assets/img/logo/logo1.webp";
import {FormattedMessage} from "react-intl";
import formatBytes from "../../components/utils/formatBytes";
import {DeleteRequest, GetRequest, PostRequest} from "../../components/request";
import Notify from "../../components/Baran/noty/notify";
import {Edit, Eye, Plus, Trash} from "react-feather";
import JoditEditor from "jodit-react";
import ListContact from '../../components/Baran/DataList/ListContact'
import {logout} from "../../redux/actions/auth/loginActions";
import ListView from "../../components/Baran/DataList/DataListConfig";
import ListFaqs from "../../components/Baran/DataList/ListFaqs";
import jalaliDate from "../../components/utils/dateFormatter";
import {history} from "../../history";
import {connect} from "react-redux";
import {baseUrl} from "../../configs/requestConfig";
import JoditConfig from "../../configs/joditConfig";

class ContactusManagement extends Component {

    constructor(props) {
        super(props);
        let token = localStorage.getItem('token') ? localStorage.getItem('token') : '';
        this.state = {
            _id: "",
            urlData: "/api/moderate/contacts",
            urlCategory: "/api/moderate/contacts",
            totalPages: 0,
            currentPage: 1,
            totalRecords: 0,
            form: 0,
            to: 0,
            Object: {
                full_name: "",
                message: "",
                mobile: "",
                created_at: ""
            },
            slugModal: "",
            contentModal: "",
            categoryDate: [],
            newItem: false,
            modal: false,
            configEditor: {
                readonly: false,
                showPlaceholder: false,
                showTooltip: false,
                buttons: [
                    'font',
                    'ol',
                    'ul',
                    'image',
                    'paragraph',
                    'fontsize',
                    'center',
                    'justify',
                    'left',
                    'right',
                    'bold',
                    'italic'
                ],
                controls: {
                    font: {
                        list: {
                            "IRANSans": "IRANSans, sans-serif"
                        }
                    }
                }, uploader: {
                    insertImageAsBase64URI: false,
                    url: baseUrl + '/api/moderate/articles/upload-image',
                    format: 'json',
                    headers: {
                        'Authorization': token
                    },
                    /* prepareData: function (data) {
                         data.append('id', 24); //
                     },*/
                    buildData: function (data) {
                        return data;
                    },
                    isSuccess: function (resp) {
                        return !resp.error;
                    },
                    getMessage: function (resp) {
                        return resp.msg;
                    },
                    process: function (resp) {
                        return {
                            files: resp.data.files || [],
                            path: resp.data.path,
                            baseurl: resp.data.baseurl,
                            error: resp.error,
                            msg: resp.data.messages
                        };
                    },
                    defaultHandlerSuccess: function (data, resp) {
                        let i,
                            field = 'files';
                        if (data[field] && data[field].length) {
                            for (i = 0; i < data[field].length; i += 1) {
                                this.s.insertImage(data.baseurl + data[field][i]);
                            }
                        }
                    },
                    error: function (e) {
                        this.e.fire('errorMessage', [e.getMessage(), 'error', 4000]);
                    }
                }

            },
            reload: false,
            update: false,
            loading_delete: false,
            loading: false,
            token: token
        }
        this.editor = React.createRef();

        this.editForm = this.editForm.bind(this);
        this.editFile = this.editFile.bind(this);
    }

    componentDidMount() {
        // this.getCategoryData();
        this.getData();
    }

    addNew = () => {
        this.setState({
            newItem: true
        })
    }

    closeNew = () => {
        this.setState({
            newItem: false
        }, function () {
            this.newForm();
        })
    }

    handleChange = (selectedOption, id) => {
        let temp = this.state.Object;
        temp[id] = selectedOption;
        this.setState({
            Object: {...temp}
        });
    };

    newForm = () => {
        this.setState({
            _id: "",
            Object: {
                full_name: "",
                message: "",
                mobile: "",
                created_at: ""
            },
            update: false
        })
    }

    editFile(event) {
        let parent = this;
        let temp = this.state.Object;
        let file = event.target.files[0];
        let reader = new FileReader();
        let target = event.target;
        reader.onload = function (e) {
            temp[target.name] = reader.result;
            temp[target.id] = file;
            parent.setState({
                Object: {...temp}
            });
        }
        try {
            reader.readAsDataURL(file);
            reader.close();
        } catch (e) {
        }
    }

    editForm(event) {
        let temp = this.state.Object;
        temp[event.target.name] = event.target.value;
        this.setState({
            Object: {...temp}
        });
    }

    handleSubmit = (event, errors, values) => {
        // if (errors.length === 0) {
        let url = this.state.urlData;
        if (this.state.update) {
            url += "/" + this.state._id + "?_method=put";
        }

        PostRequest(url, this.ObjectToData(values), {
            'Authorization': this.state.token
        }, true).then((response) => {
            let result = response.data;
            if (result.ok) {
                Notify('success', 'top-right', 'با موفقیت ثبت شد');
                this.closeNew();
            } else {
                let message = '';
                Object.entries(result.errors).map(result => {
                    result[1].map(function (value) {
                        message += value + '\n';
                    });
                });
                Notify('error', 'top-right', message);
            }
        }).catch((err) => {
            if (err.response) {
                if (err.response.status === 401)
                    this.props.logout()
            } else
                Notify('error', 'top-right', "خطایی رخ داده است");
        }).finally(() => {
            // this.setState({
            //     reload: !this.state.reload,
            //     loading: false
            // });
            // this.getData();
        });
        // } else
        //     Notify('info', 'top-left', "لطفا اطلاعات فرم را به درستی تکمیل کنید");
    }

    handleChangeSidebar = boolean => {
        this.setState({
            sidebar: boolean
        });
    }



    onChangeContent = (newContent) => {
        let temp = this.state.Object;
        temp.content = newContent;
        this.setState({
            Object: {...temp}
        })
    }

    ObjectToData(data) {
        let formData = new FormData();
        Object.entries(data).map(function (value, index, array) {
            formData.append(value[0], value[1]);
        })
        return formData;
    }

    getData = () => {
        let parent = this;
        let search = this.state.search;
        // let url = this.state.urlData + '?page=' + this.state.currentPage;
        // if (search) {
        //     url += "&s=" + search;
        // }
        GetRequest("/api/moderate/contacts",
            {
                'Authorization': this.state.token
            }).then((response) => {
            let result = response.data;
            if (result.ok) {
                result = result.data.data;
                console.log(result)
                parent.setState({
                    data: result
                }, function () {
                })
            }
        }).catch(function (error) {
            if (error.response) {
                if (error.response.status === 401)
                    logout()
            }
            Notify('error', 'top-right', "خطایی رخ داده است");
        });
    }

    getForm = (id) => {
        let parent = this;
        GetRequest(this.state.urlData + "/" + id,
            {
                'Authorization': this.state.token
            }).then((response) => {
            let result = response.data;
            if (result.ok) {
                result = result.data;
                let temp = parent.state.Object;
                temp.full_name = result.full_name;
                temp.message = result.message;
                temp.mobile = result.mobile;
                temp.created_at = result.created_at;
                this.setState({
                    Object: {...temp},
                    update: true,
                    _id: result.id
                }, function () {
                    parent.addNew();
                })
            }
        }).catch(function (error) {
            if (error.response) {
                if (error.response.status === 401)
                    logout()
            }
            Notify('error', 'top-right', "خطایی رخ داده است");
        });
    }

    toggleModal = (slug = "", content = "") => {
        this.setState({
            slugModal: slug,
            contentModal: content,
            modal: !this.state.modal
        })
    }

    Delete = () => {
        let parent = this;
        this.setState({
            loading_delete: true
        });
        DeleteRequest(this.state.urlData + "/" + this.state._id, {
            'Authorization': this.state.token
        }).then((response) => {
            let result = response.data;
            if (result.ok) {
                Notify('success', 'top-right', 'با موفقیت انجام شد');
                parent.getData();
                parent.setState({
                    reload: !this.state.reload
                });
            } else {
                let message = '';
                Object.entries(result.errors).map(result => {
                    result[1].map(function (value) {
                        message += value + '\n';
                    });
                });
                Notify('error', 'top-right', message);
            }
        }).catch((err) => {
            if (err.response) {
                if (err.response.status === 401)
                    this.props.logout()
            } else
                Notify('error', 'top-right', "خطایی رخ داده است");
        }).finally(() => {
            parent.setState({
                loading_delete: false,
                modal_delete: false
            })
        })
    }

    setCurrentID = (id) => {
        this.setState({
            _id: id,
            modal_delete: true
        });
    };

    toggleModalDelete = () => {
        this.setState(prevState => ({
            modal_delete: !prevState.modal_delete
        }))
    }

    goToArticle = (slug) => {
        history.push(slug)
    }

    render() {

        const modal_delete = <>
            <Modal
                isOpen={this.state.modal_delete}
                toggle={this.toggleModalDelete}
                className="modal-dialog-centered">
                <ModalHeader toggle={this.toggleModalDelete} className="bg-danger">
                    حذف
                </ModalHeader>
                <ModalBody>
                    آیا می خواهید گزینه مورد نظر حذف شود؟
                </ModalBody>
                <ModalFooter>
                    <Button color="Primary" onClick={this.toggleModalDelete} disabled={this.state.loading_delete}
                            className="bg-Primary">
                        بستن
                    </Button>
                    <Button color="danger" onClick={this.Delete} disabled={this.state.loading_delete}
                            className="bg-danger">
                        {this.state.loading_delete ?
                            "درحال حذف"
                            :
                            "حذف"
                        }
                    </Button>
                </ModalFooter>
            </Modal>
        </>;

        const form =
            <>
                <AvForm onSubmit={this.handleSubmit}>
                    <Row>
                        <Col sm={12} md={4}>
                            <AvGroup>
                                <Label className="mb-1" for="full_name">نام و نام خانوادگی</Label>
                                <AvInput
                                    name="full_name"
                                    id="full_name"
                                    value={this.state.Object.full_name}
                                    onChange={this.editForm}
                                    required
                                />
                                <AvFeedback>الزامی می باشد</AvFeedback>
                            </AvGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={12} md={12}>
                            <AvGroup>
                                <Label className="mb-1" for="answer">پاسخ</Label>
                                <AvInput
                                    name="answer"
                                    id="answer"
                                    value={this.state.Object.answer}
                                    onChange={this.editForm}
                                    required
                                />
                                <AvFeedback>الزامی می باشد</AvFeedback>
                            </AvGroup>
                        </Col>
                    </Row>

                    <FormGroup className="text-center row">
                        <Col sm={12} md={4}>
                            <Button.Ripple className="w-100" color="danger" onClick={this.closeNew}>
                                بستن
                            </Button.Ripple>
                        </Col>
                        <Col sm={12} md={8}>
                            <Button.Ripple disabled={this.state.loading} className="w-100" color="primary">
                                {this.state.update ? "بروزرسانی" : "ثبت"}
                            </Button.Ripple>
                        </Col>
                    </FormGroup>
                </AvForm>
            </>;

        const ActionsComponent = props => {
            return (
                <div className="data-list-action">
                    {/*<Edit*/}
                    {/*    id="edit_tooltip"*/}
                    {/*    className="cursor-pointer mr-1"*/}
                    {/*    size={20}*/}
                    {/*    onClick={() => {*/}
                    {/*        this.getForm(props.row.id)*/}
                    {/*    }}*/}
                    {/*/>*/}
                    {/*<UncontrolledTooltip*/}
                    {/*    placement="top"*/}
                    {/*    target="edit_tooltip">*/}
                    {/*    ویرایش*/}
                    {/*</UncontrolledTooltip>*/}
                    <Trash
                        id="delete_tooltip"
                        className="cursor-pointer mr-1"
                        size={20}
                        onClick={() => {
                            this.setCurrentID(props.row.id);
                        }}
                    />
                    <UncontrolledTooltip
                        placement="top"
                        target="delete_tooltip">
                        حذف
                    </UncontrolledTooltip>
                    <Eye
                        id="show_tooltip"
                        className="cursor-pointer"
                        size={20}
                        onClick={() => this.toggleModal(props.row.slug, props.row.message)}
                    />
                    <UncontrolledTooltip
                        placement="top"
                        target="show_tooltip">
                        مشاهده پیام
                    </UncontrolledTooltip>
                </div>
            )
        }
        const col = [
            {
                name: <FormattedMessage id="FullName"/>,
                selector: "full_name",
                sortable: true,
                width: "20%"
            },
            {
                name: <FormattedMessage id="mobile"/>,
                selector: "mobile",
                sortable: true,
                width: "30%"
            },
            {
                name: <FormattedMessage id="CreatedAt"/>,
                selector: "created_at",
                sortable: true,
                width: "30%"
            },
            {
                name: <FormattedMessage id="Actions"/>,
                sortable: false,
                cell: row => (
                    <ActionsComponent row={row}/>
                )
            }
        ];
        const modal =
            <Modal size="lg" centered isOpen={this.state.modal}
                   toggle={() => this.toggleModal()}>
                <ModalHeader className="bg-primary">
                    متن پیام
                </ModalHeader>
                <ModalBody>
                    <div dangerouslySetInnerHTML={{
                        __html: this.state.contentModal
                    }}>
                    </div>
                </ModalBody>
            </Modal>;
        return (
            <React.Fragment>
                <Breadcrumbs
                    breadCrumbTitle="ContactUs"
                    /* breadCrumbParent="ArticleManagement"
                     breadCrumbActive="Articles"*/
                />
                {/*{!this.state.newItem &&*/}
                {/*    <Button*/}
                {/*        className="add-new-btn mb-1"*/}
                {/*        color="primary"*/}
                {/*        onClick={this.addNew}*/}
                {/*        outline>*/}
                {/*        <Plus size={15}/>*/}
                {/*        <span className="align-middle">*/}
                {/*        <FormattedMessage id="Add New"/>*/}
                {/*    </span>*/}
                {/*    </Button>*/}
                {/*}*/}
                <Collapse className="m-0 sub-category" isOpen={this.state.newItem}>
                    <Card>
                        <CardBody>
                            {form}
                        </CardBody>
                    </Card>
                </Collapse>
                <Row>
                    <Col sm="12">
                        <ListContact
                            Col={col}
                            urlData={this.state.urlData}
                            urlSearch={this.state.urlData}
                            viewForm={form}
                            onChangeSidebar={this.handleChangeSidebar}
                            sidebar={this.state.sidebar}
                            newItem={true}
                            newForm={this.newForm}
                            reload={this.state.reload}
                            localeDisabled={true}
                        />
                    </Col>
                </Row>
                {modal}
                {modal_delete}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return state
}
export default connect(mapStateToProps, {logout})(ContactusManagement)




















